/**
 * Hide internal Buy 2 combo line item properties in GoKwik / dynamic cart drawers.
 */
(function () {
  'use strict';

  var HIDDEN_KEYS = [
    '_bundle_id',
    '_bundle_type',
    '_bundle_price',
    '_pair',
    'Pair',
    '_engraving_required',
    'engraving_required',
    '_image_url',
    'image_url',
    'Personalization',
    'Custom Name'
  ];

  var HIDDEN_TEXT_RE = new RegExp(
    '^(' + HIDDEN_KEYS.map(function (key) {
      return key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }).join('|') + ')\\s*:',
    'i'
  );

  var CART_ROOT_SELECTORS = [
    '.cart-drawer',
    '.side-cart',
    '.mini-cart',
    '#mini-cart',
    '.rabitat-mini-cart',
    '[class*="gokwik"]',
    '[class*="kwik"]',
    '[class*="Kwik"]',
    '[class*="cart-drawer"]',
    '[class*="side-cart"]',
    '[class*="sideCart"]',
    '[class*="SideCart"]',
    '[id*="cart-drawer"]',
    '[id*="side-cart"]',
    '.rebuy-cart',
    '.product-item-meta__property-list'
  ];

  function isHiddenKey(key) {
    if (!key) return false;
    key = String(key).trim();
    if (key.charAt(0) === '_') return true;
    return HIDDEN_KEYS.indexOf(key) !== -1;
  }

  function isHiddenText(text) {
    if (!text) return false;
    text = String(text).trim();
    if (!text || text.length > 160) return false;
    if (HIDDEN_TEXT_RE.test(text)) return true;
    return HIDDEN_KEYS.indexOf(text) !== -1;
  }

  function hideNode(node) {
    if (!node || node.dataset.buy2Hidden === 'true') return;

    var row = node.closest(
      'li, tr, dd, dt, p, span, div, [class*="property"], [class*="Property"], .product-item-meta__property'
    ) || node;

    if (!row || row === document.body || row.dataset.buy2Hidden === 'true') return;

    row.dataset.buy2Hidden = 'true';
    row.style.setProperty('display', 'none', 'important');
    row.style.setProperty('visibility', 'hidden', 'important');
    row.style.setProperty('height', '0', 'important');
    row.style.setProperty('max-height', '0', 'important');
    row.style.setProperty('overflow', 'hidden', 'important');
    row.style.setProperty('margin', '0', 'important');
    row.style.setProperty('padding', '0', 'important');
    row.setAttribute('aria-hidden', 'true');
  }

  function scanRoot(root) {
    if (!root || root.nodeType !== 1) return;

    root.querySelectorAll('[data-item-property], [data-property], [data-name], [data-key]').forEach(function (el) {
      var key = el.getAttribute('data-item-property') ||
        el.getAttribute('data-property') ||
        el.getAttribute('data-name') ||
        el.getAttribute('data-key');

      if (isHiddenKey(key)) hideNode(el);
    });

    root.querySelectorAll('li, p, span, div, dd, dt').forEach(function (el) {
      if (el.dataset.buy2Hidden === 'true') return;
      if (el.querySelector('[data-buy2-combo-root]')) return;
      if (el.children.length > 6) return;

      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (isHiddenText(text)) hideNode(el);
    });

    root.querySelectorAll('span, div, dd, dt, p, li').forEach(function (el) {
      if (el.dataset.buy2Hidden === 'true') return;
      if (el.children.length > 0) return;

      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (isHiddenKey(text)) hideNode(el.parentElement || el);
    });
  }

  function hideBuy2BundleProperties() {
    var roots = [];

    CART_ROOT_SELECTORS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        if (roots.indexOf(el) === -1) roots.push(el);
      });
    });

    if (!roots.length) roots.push(document.body);

    roots.forEach(scanRoot);
  }

  var debounceTimer;
  function scheduleHide() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(hideBuy2BundleProperties, 80);
  }

  hideBuy2BundleProperties();
  setTimeout(hideBuy2BundleProperties, 400);
  setTimeout(hideBuy2BundleProperties, 1200);

  document.addEventListener('cart:updated', scheduleHide);
  document.addEventListener('cart:refresh', scheduleHide);
  document.addEventListener('rabitat:cart:updated', scheduleHide);
  document.addEventListener('variant:added', scheduleHide);
  window.addEventListener('load', scheduleHide);

  var observer = new MutationObserver(scheduleHide);

  function startObserver() {
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
})();
